import * as yup from 'yup';

// Add method
yup.addMethod(yup.string, 'stripEmptyString', function () {
    return this.transform((value) => (value === '' ? '' : value));
});

const SUPPORTED_FORMATS = [
    "application/pdf",
];

export const generateValidationSchema = (fileFields) => {
    const schema = {
        numero_documento: yup.string().stripEmptyString().required('required'),
        tipo_compania: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        tipo_documento: yup.number().required('required'),
        razon_social: yup.string().trim().required('required'),
        direccion_principal: yup.string().trim().required('required'),
        codigo_postal: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        telefono_fijo: yup.string().trim().required('required'),
        telefono_celular: yup.string().trim().required('required'),
        correo_empresarial: yup.string().trim().email('Correo electrónico no es válido.').required('required'),
        pais: yup.string().trim().stripEmptyString().required('required'),
        departamento: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        ciudad: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        ciudad_nombre: yup.string().trim().required('required'),
        matricula_mercantil: yup.string().trim().required('required'),
        sagrilaft: yup.number().required('required'),
        sarlaft: yup.number().required('required'),
        prevension_lavados_activos: yup.number().required('required'),
        regimen_tributario:  yup
        .array()
        .of(yup.string()),
        responsable_iva: yup.number().required('required'),
        nombre_rep: yup.string().trim().required('required'),
        tipo_documento_rep:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        numero_de_identidad_rep:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        correo_electronico_rep: yup.string().email('Email is not valid').required('required'),
        numero_telefonico_rep:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        persona_expuesta:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        tamano_empresa:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        entidad_financiera: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        numero_cuenta: yup.string().trim().required('required'),
        tipo_cuenta:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        nombre_contacto_financiero: yup.string().trim().required('required'),
        cargo_contacto_financiero: yup.string().trim().required('required'),
        telefono_contacto_financiero:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        correo_electronico_financiero: yup.string().trim().email('Correo electrónico no es válido.').required('required'),
        nombre_contacto_comercial: yup.string().trim().required('required'),
        cargo_contacto_comercial: yup.string().trim().required('required'),
        telefono_contacto_comercial:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        correo_electronico_contacto_comercial: yup.string().trim().email('Correo electrónico no es válido.').required('required'),
        expbienes_servicios: yup.string().trim().required('required'),
        nombre_contacto_lg: yup.string().trim().required('required'),
        cargo_contacto_lg: yup.string().trim().required('required'),
        telefono_contacto_lg:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
        correo_electronico_contacto_lg: yup.string().trim().email('Correo electrónico no es válido.').test('valid-domain', 'Invalid email domain please check and try again', (value) => {
            return value.endsWith('@lge.com');            
        }).required('required'),
        check_habeas_data: yup.boolean().required('required').oneOf([true], 'required'),
        ...fileFields.reduce((acc, field) => {
          if (field.requerid === 'S') {
            acc[`iddir_${field.iddir}`] = yup.mixed()
            .test("required", "required", (file) => {
              if (file) return true;
              return false;
            }).test(
              "fileFormat",
              "Only the following formats are accepted:  .pdf",
              value => value && SUPPORTED_FORMATS.includes(value.type)
            );
          } else {
            acc[`iddir_${field.iddir}`] = yup.mixed().nullable()
          }
          
          return acc;
        }, {}),
        
    }

    return yup.object(schema);
}

export const generateValidationSchemaNoFiles = yup.object().shape({
    numero_documento: yup.string().stripEmptyString().required('required'),
    tipo_compania: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    tipo_documento: yup.number().required('required'),
    razon_social: yup.string().trim().required('required'),
    direccion_principal: yup.string().trim().required('required'),
    codigo_postal: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    telefono_fijo: yup.string().trim().required('required'),
    telefono_celular: yup.string().trim().required('required'),
    correo_empresarial: yup.string().trim().email('Correo electrónico no es válido.').required('required'),
    pais: yup.string().trim().stripEmptyString().required('required'),
    departamento: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    ciudad: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    ciudad_nombre: yup.string().trim().required('required'),
    matricula_mercantil: yup.string().trim().required('required'),
    sagrilaft: yup.number().required('required'),
    sarlaft: yup.number().required('required'),
    prevension_lavados_activos: yup.number().required('required'),
    regimen_tributario: yup.number().required('required'),
    responsable_iva: yup.number().required('required'),
    nombre_rep: yup.string().trim().required('required'),
    tipo_documento_rep:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    numero_de_identidad_rep:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    correo_electronico_rep: yup.string().email('Email is not valid').required('required'),
    numero_telefonico_rep:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    persona_expuesta:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    tamano_empresa:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    entidad_financiera: yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    numero_cuenta: yup.string().trim().required('required'),
    tipo_cuenta:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    nombre_contacto_financiero: yup.string().trim().required('required'),
    cargo_contacto_financiero: yup.string().trim().required('required'),
    telefono_contacto_financiero:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    correo_electronico_financiero: yup.string().trim().email('Correo electrónico no es válido.').required('required'),
    nombre_contacto_comercial: yup.string().trim().required('required'),
    cargo_contacto_comercial: yup.string().trim().required('required'),
    telefono_contacto_comercial:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    correo_electronico_contacto_comercial: yup.string().trim().email('Correo electrónico no es válido.').required('required'),
    expbienes_servicios: yup.string().trim().required('required'),
    nombre_contacto_lg: yup.string().trim().required('required'),
    cargo_contacto_lg: yup.string().trim().required('required'),
    telefono_contacto_lg:  yup.number().transform((value) => Number.isNaN(value) ? null : value ).required('required'),
    correo_electronico_contacto_lg: yup.string().trim().email('Correo electrónico no es válido.').test('valid-domain', 'Invalid email domain please check and try again', (value) => {
        return value.endsWith('@lge.com');            
    }).required('required'),
    check_habeas_data: yup.boolean().required('required').oneOf([true], 'required')    
})    